import React from "react";
import {connect} from 'dva';
import {framework_tool, component_tool, utils_tool} from '../../../../tool'

import {templateConfig, reduxTemplateConfig} from './config';
import {Descriptions} from 'antd';
import moment from "moment";

let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool
let {WizBrowserExport, WizModal, WizCard} = component_tool
let {Session} = utils_tool

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}

class ActivityMessageManager extends WizContainer {
  componentName = 'activityMessageManager'

  constructor(props) {
    super(props)
    const {history} = props
    let activityInfo = {};
    if (history.location && history.location.pathname === '/interact/activity/activityMessage') {
      if (history.location && history.location.record) {
        activityInfo = history.location.record
        Session.set('activityInfo', activityInfo)
      } else {
        activityInfo = Session.get('activityInfo') || {}
      }
    }
    this.activityInfo = activityInfo
    this.filters = {}
    this.state = {
      activityId: activityInfo.id || activityInfo.activityId ,
    }
  }

  _componentDidMount() {
    if (this.state && this.state.activityId) {
      this.doAction({
        path: 'activity/look',
        payload: {
          key: 'activityInfo',
          apiParams: {id: this.state.activityId}
        }
      })
    }
    this._getActivityMessageList();
  }

  _getActivityMessageList(apiParams = {}) {
    let {activityId} = this.state
    this.doAction({
      path: 'activityMessage/listByPage',
      payload: {
        key: 'activityMessage@listByPage',
        apiParams: {
          activityId: activityId,
          ...apiParams
        }
      }
    })
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig({activityId: this.state.activityId}),
      apiDataFormat: {
        enable: this._handleCMD
      },
      activityId: this.state.activityId
    })
    let {activityInfo} = this.props
    if(activityInfo && activityInfo.success) {
      this.activityInfo = activityInfo.data
    }
    const items = this.activityInfo
    let applyName = ''
    if (items['apply'] === 0) {
      applyName = '否'
    } else {
      applyName = '是'
    }
    return (
      <React.Fragment>
        <WizCard title={'活动信息'}>
          <Descriptions column={2} style={{paddingLeft: 25}}>
            <Descriptions.Item label='活动名称'>{items.name}</Descriptions.Item>
            <Descriptions.Item label='活动时间'>{formatterDate(items.startTime)} ~ {formatterDate(items.endTime)}</Descriptions.Item>
            <Descriptions.Item label='主办方'>{items.sponsor}</Descriptions.Item>
            {/*<Descriptions.Item label='是否需要报名'>{applyName}</Descriptions.Item>*/}
          </Descriptions>
        </WizCard>

        <WizCard title={'活动公告'}>
          <WizReduxTemplate {..._reduxTemplateConfig}/>
        </WizCard>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let {activity, activityMessage} = state
  const activityInfo = modelUtils.getModelEntity(activity, 'activityInfo');
  const messageList = modelUtils.getModelEntity(activityMessage, 'activityMessage@listByPage')
  const load = modelUtils.getLoadingState(state, 'activityMessage')
  return {
    activityInfo,
    messageList,
    ...load
  }
};

export default connect(mapStateToProps)(ActivityMessageManager);
